/**
 * ============================================================
 *  PRODUCT COUNTDOWN — FINAL INDEPENDENT MODULE (Ella / Halo)
 *  ------------------------------------------------------------
 *  ADDED BY TDA — COMPLETE STANDALONE VERSION
 *
 *  ✅ Fully decoupled from theme.js
 *  ✅ Self-initializing (no external calls needed)
 *  ✅ Still attaches cleanly to `window.halo` namespace
 *  ✅ Supports both countdown modes:
 *       1. Date‑based countdown (Theme Editor standard)
 *       2. Auto‑Reloading 24‑hour countdown (per visitor)
 *
 *  🔹 DEFAULT MODE (auto‑reload OFF)
 *        → Uses Theme Editor's “Countdown Time” date
 *
 *  🔹 AUTO‑RELOAD MODE (auto‑reload ON)
 *        → Starts 24h timer on visitor's first visit
 *        → Persists in localStorage
 *        → Resets every 24h
 *        → Days hidden (H:M:S only)
 *
 *  🔹 Zero dependence on theme.js:
 *        → No need for halo.initProductView()
 *        → No need for halo.productCountdown() call in theme.js
 *
 *  🔹 Auto‑detects countdown blocks on any page (PDP, LP, sections)
 *
 * ============================================================
 */

(function() {

  //--------------------------------------------------------------
  //  ENSURE HALO NAMESPACE
  //--------------------------------------------------------------
  window.halo = window.halo || {};


  //--------------------------------------------------------------
  //  COUNTDOWN FUNCTION (REUSABLE FOR ANY SCOPE)
  //--------------------------------------------------------------
  window.halo.productCountdown = function($scope) {
    var wrapper = $scope.find('[data-countdown-id]');
    if (!wrapper.length) return;

    var countDown     = wrapper.data('countdown'),
        autoReload    = String(wrapper.data('auto-reload')).toLowerCase() === 'true',
        countDownText = (window.countdown && window.countdown.text) ? window.countdown.text : 'Offer Ends In',
        countDownDate;

    //--------------------------------------------------------------
    //  FORMAT COUNTDOWN TEXT (Split after comma if exists)
    //--------------------------------------------------------------
    var splitText = countDownText.split(',');
    var line1 = splitText[0] ? splitText[0].trim() : '';
    var line2 = splitText[1] ? splitText[1].trim() : '';

    // Build multiline text HTML
    var formattedText =
    '<span class="text">' +
        '<span class="line1">' + line1 + '</span>' +
        (line2 ? '<span class="line2">' + line2 + '</span>' : '') +
    '</span>';

    //--------------------------------------------------------------
    //  DETERMINE TARGET DATE
    //--------------------------------------------------------------
    if (autoReload) {
      var stored = localStorage.getItem('energyrocksCountdownEnd');
      var now = Date.now();

      if (stored && Number(stored) > now) {
        countDownDate = Number(stored);
      } else {
        countDownDate = now + (24 * 60 * 60 * 1000);
        localStorage.setItem('energyrocksCountdownEnd', countDownDate);
      }

    } else {
      countDownDate = new Date(countDown).getTime();
    }


    //--------------------------------------------------------------
    //  COUNTDOWN LOOP
    //--------------------------------------------------------------
    var countdownfunction = setInterval(function() {
      var now = Date.now(),
          distance = countDownDate - now;

      // Handle expired timer
      if (distance < 0) {
        if (autoReload) {
          countDownDate = now + (24 * 60 * 60 * 1000);
          localStorage.setItem('energyrocksCountdownEnd', countDownDate);
          distance = countDownDate - now;
        } else {
          clearInterval(countdownfunction);
          wrapper.remove();
          return;
        }
      }

      var days    = Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds = Math.floor((distance % (1000 * 60)) / 1000),
          strCountDown;


      //--------------------------------------------------------------
      //  TEMPLATE RENDERING
      //--------------------------------------------------------------
      if (autoReload) {
        // Auto‑reload mode (H:M:S only)
        strCountDown =
          '<span class="text"><span>' + formattedText + '</span></span>' +
          '<span class="num"><span class="count">' + hours   + '</span><span class="label">' + window.countdown.hour + '</span></span>' +
          '<span class="num"><span class="count">' + minutes + '</span><span class="label">' + window.countdown.min  + '</span></span>' +
          '<span class="num"><span class="count">' + seconds + '</span><span class="label">' + window.countdown.sec  + '</span></span>';
      }

      else if (wrapper.is('.style-2, .style-3')) {
        // Style 2 / 3 variant labels
        strCountDown =
          '<span class="text"><span>' + formattedText + '</span></span>' +
          '<span class="num"><span class="count">' + days    + '</span><span class="label">' + window.countdown.day_2  + '</span></span>' +
          '<span class="num"><span class="count">' + hours   + '</span><span class="label">' + window.countdown.hour_2 + '</span></span>' +
          '<span class="num"><span class="count">' + minutes + '</span><span class="label">' + window.countdown.min_2  + '</span></span>' +
          '<span class="num"><span class="count">' + seconds + '</span><span class="label">' + window.countdown.sec_2  + '</span></span>';
      }

      else {
        // Standard (D:H:M:S)
        strCountDown =
          '<span class="text"><span>' + formattedText + '</span></span>' +
          '<span class="num"><span class="count">' + days    + '</span><span class="label">' + window.countdown.day  + '</span></span>' +
          '<span class="num"><span class="count">' + hours   + '</span><span class="label">' + window.countdown.hour + '</span></span>' +
          '<span class="num"><span class="count">' + minutes + '</span><span class="label">' + window.countdown.min  + '</span></span>' +
          '<span class="num"><span class="count">' + seconds + '</span><span class="label">' + window.countdown.sec  + '</span></span>';
      }


      //--------------------------------------------------------------
      //  OUTPUT UPDATE
      //--------------------------------------------------------------
      wrapper.html(strCountDown);
      wrapper.addClass('show');

    }, 1000);
  };


  //--------------------------------------------------------------
  //  AUTO‑INIT ON DOM READY (NO theme.js REQUIRED)
  //--------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', function() {

    if (typeof jQuery === 'undefined') return; // require jQuery

    // Find every countdown block on the page
    var $blocks = jQuery('[data-countdown-id]');

    if ($blocks.length) {
      $blocks.each(function() {
        // Use an appropriate parent scope (or fallback to document)
        var $scope = jQuery(this).closest('section, .product, .page-width, body');
        window.halo.productCountdown($scope);
      });
    }
  });

})();
